import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { DefaultLayout } from './default-layout';
import { EmbeddedLayout } from './embedded-layout';

interface IDashboardLayout extends PropsWithChildren<Record<string, unknown>> {
  toolbar?: React.ReactNode;
  searchDrawer?: React.ReactNode;
  embedded?: boolean;
}

function Layout({ children, embedded = false }: { children: React.ReactNode; embedded: boolean }) {
  return embedded ? <EmbeddedLayout>{children}</EmbeddedLayout> : <DefaultLayout>{children}</DefaultLayout>;
}

export function DashboardLayout(props: IDashboardLayout) {
  const { toolbar, searchDrawer, children, embedded = false } = props;

  return (
    <Layout embedded={embedded}>
      <Box display="flex" flexDirection="column" height="100%">
        {toolbar}
        <Box flex="1 1 auto">{children}</Box>
      </Box>
      {searchDrawer}
    </Layout>
  );
}
